import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useInformacoesHorarioSaida, { LOAD_MESSAGE } from './InformacoesHorarioSaidaHook'
import { tableCellCentered } from '../../../../assets/js/styles'
import { Column } from 'primereact/column'
import {
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  DateTime,
  PageHeader,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import EnvioHorarioSaida from './EnvioHorarioSaida'

function InformacoesHorarioSaida({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useInformacoesHorarioSaida()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getFleets(selectedTp)
        localDispatch.getMotivosAtraso(selectedTp)
        break

      case LOAD_MESSAGE.SAVE_DEPARTURE_TIME:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveDepartureTimeInfo(selectedTp, state.departureTimeWithReason, state.frotas)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  return (
    <div>
      <PageHeader>3.15 - Informações de Horario Saida</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div>
            <EnvioHorarioSaida
              onBtnSalvarInfo={localDispatch.onBtnSalvarInfo}
              motivosAtraso={state.motivosAtraso}
            />
            <div style={{ marginTop: 20 }}>
              <DataTable
                value={state.frotas}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.onGlobalFilterChange(value)}
                  />
                }
                globalFilter={state.globalFilter}
                emptyMessage="Não existem veiculos para atribuir as informações "
                paginator={true}
                rows={10}
                style={{ textAlign: 'center' }}
                responsive
              >
                <Column
                  field="selected"
                  style={tableCellCentered(60)}
                  body={frota => (
                    <CustomCheckbox
                      checked={frota.selected}
                      onChange={checked => localDispatch.onCheckBoxRowClicked(frota, checked)}
                    />
                  )}
                />
                <Column
                  field="expected_date"
                  header="Data Prev. Entrega"
                  style={tableCellCentered(200)}
                  body={frota => <DateTime>{frota.expected_date}</DateTime>}
                />
                <Column field="vehicle_badge" header="Placa" style={tableCellCentered(150)} />
                <Column field="driver" header="Motorista" style={tableCellCentered(200)} />
                <Column field="qte_deliveries" style={tableCellCentered()} header="Qte Identif." />
                <Column field="departure_time" style={tableCellCentered()} header="Horário Saida" />
                <Column
                  field="motivo_atraso"
                  style={tableCellCentered(300)}
                  header="Motivo de Atraso"
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(InformacoesHorarioSaida))
